import { render, staticRenderFns } from "./NewCategoryDialog.vue?vue&type=template&id=66526100&scoped=true&"
import script from "./NewCategoryDialog.vue?vue&type=script&lang=ts&"
export * from "./NewCategoryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewCategoryDialog.vue?vue&type=style&index=0&id=66526100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66526100",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextField,VTextarea})
